import React, { useEffect, useState } from "react";
import '../../components/styles/FABBusiness.css'; // CSS 파일 임포트
import FABBusinessDetails from "./FABBusinessDetails";
import { API_BASE_URL_AGENT_DEV } from "../../services/apiConfig";

interface FABBusinessProps {
    setCarddetailmodalOpen1: (open: boolean) => void;
    businessdata: any;
}

const FABBusiness: React.FC<FABBusinessProps> = ({ setCarddetailmodalOpen1, businessdata }) => {
    const [carddetailmodalOpen, setCarddetailmodalOpen] = useState(false);
    const [businessdatalist, setBusinessDatalist] = useState<any>(null);
    const [expandedIndices, setExpandedIndices] = useState<number[]>([]); // 클릭 시 정보 표시 여부 상태 추가
    const [transactions, setTransactions] = useState<any[]>([]);

    const handleToggle = (index: number) => {
        setExpandedIndices(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        ); // 상태 반전
    };

    const handlPDFdownload = (fnbContractSeq: any) => {
        console.log("ㅎㅎ" + fnbContractSeq)
        fetchPDFdownload(fnbContractSeq);

    };

    const fetchPDFdownload = async (fnbContractSeq: number) => {
        try {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/contracts/download/pdf/${fnbContractSeq}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // 응답 상태가 200인지 확인
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Blob 형태로 응답받기
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob); // Blob URL 생성
            const a = document.createElement('a'); // 링크 요소 생성
            a.href = url;
            a.download = `contract_${fnbContractSeq}.pdf`; // 다운로드할 파일 이름 설정
            document.body.appendChild(a); // 링크 요소를 DOM에 추가
            a.click(); // 링크 클릭하여 다운로드 트리거
            a.remove(); // 링크 요소 제거
            window.URL.revokeObjectURL(url); // Blob URL 해제

        } catch (error) {
            console.error("(PDFDownload) Error fetching data:", error);
        }
    };
    const getStatusClass = (status: string) => {
        switch (status) {
            case "거래중":
                return "status-ongoing";
            case "완료":
                return "status-completed";
            case "취소":
                return "status-cancelled";
            default:
                return "";
        }
    };

    const fetchBusinessData = async (fnbContractSeq: number) => {
        try {
            console.log(`${API_BASE_URL_AGENT_DEV}/fnb/contracts/now/${fnbContractSeq}`);
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/contracts/now/${fnbContractSeq}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("data json : " + JSON.stringify(data, null, 2));
            console.log("data json : " + JSON.stringify(data.data, null, 2));
            setBusinessDatalist(data.data);
            createTransactions(data.data);
        } catch (error) {
            console.error("(ExcelUpload) Error fetching data:", error);
        }
    };
    const handleDetailsClick = (clubName: string) => {
        console.log("사용현황 실행")
        setCarddetailmodalOpen(!carddetailmodalOpen);
    };

    const createTransactions = (data: any) => {
        const newTransactions = [
            {
                status: getStatusText(data.status),
                period: `${data.startDateTime} ~ ${data.endDateTime}`,
            },
            // 여기에 추가 거래를 넣을 수 있습니다.
        ];
        setTransactions(newTransactions);
    };

    useEffect(() => {
        if (businessdata?.fnbContractSeq) {
            fetchBusinessData(businessdata.fnbContractSeq);
        }
    }, [businessdata]);

    const getStatusText = (status: string) => {
        switch (status) {
            case "IN_PROGRESS":
                return "거래중";
            case "CANCELLED":
                return "취소";
            case "WAITING":
                return "대기중";
            case "EXPIRED":
                return "완료";
            default:
                return "";
        }
    };

    return (
        <div className="layout">
            {carddetailmodalOpen ? (
                <div className="main-content">
                    <FABBusinessDetails businessdata={businessdata} setCarddetailmodalOpen={setCarddetailmodalOpen} />
                </div>
            ) : (
                <div className="main-content-business">
                    <div className="transaction-header">
                        <span className="back-button" onClick={() => setCarddetailmodalOpen1(false)}>&lt;</span>
                    </div>

                    <div className="transaction-header">
                        | {businessdata.consumerClubName}과 거래중인 내역입니다.
                    </div>

                    {/* transactions가 빈 배열이 아닐 때만 map 호출 */}
                    {transactions && transactions.length > 0 ? (
                        transactions.map((transaction, index) => (
                            <div key={index} style={{ width: '100%' }}>
                                <div
                                    className={`long-box ${getStatusClass(transaction.status)}`}
                                    onClick={() => handleToggle(index)}
                                >
                                    <div className="transaction-details">
                                        <span className="transaction-status">{transaction.status}</span>
                                        <span className="transaction-period">{transaction.period}</span>
                                    </div>
                                    <span className={`arrow ${getStatusClass(transaction.status)}`}>
                                        {expandedIndices.includes(index) ? '↑' : '↓'}
                                    </span>
                                </div>

                                {expandedIndices.includes(index) && businessdatalist && (
                                    <div className="info-list">
                                        <ul className="info-list ul">
                                            <li className="contact">대표 연락처</li>
                                            <div className="divider" />
                                            <li className="contact">식당 : {businessdatalist.providerMobileNumber}</li>
                                            <li className="contact">회사 : {businessdatalist.consumerMobileNumber}</li>
                                            <div className="divider" />

                                            <li className="contact">선불 여부</li>
                                            <li className="contact">
                                                {businessdatalist.isPrepaid ? '선불이 가능합니다.' : '선불이 불가능합니다.'}
                                            </li>
                                            <div className="divider" />

                                            <li className="contact">선불 금액</li>
                                            <li className="contact">{businessdatalist.paidMaxAmount.toLocaleString()}원 / 0원</li>
                                            <div className="divider" />

                                            <li className="contact">직원 사용 상한 금액</li>
                                            <li className="contact">{businessdatalist.regularMaxAmount.toLocaleString()}원</li>
                                            <div className="divider" />
                                            <li className="contact">매니저 사용 상한 금액</li>
                                            <li className="contact">{businessdatalist.managerMaxAmount.toLocaleString()}원</li>
                                            <div className="divider" />

                                            <li className="contact">메뉴</li>
                                            {businessdatalist && businessdatalist.menu && JSON.parse(businessdatalist.menu).menu ? (
                                                JSON.parse(businessdatalist.menu).menu.map((menu: any, idx: number) => (
                                                    <li className="contact" key={idx}>
                                                        {menu.name}: {menu.price}원
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="contact">메뉴가 없습니다.</li>
                                            )}
                                        </ul>

                                        <button className="business-button" onClick={() => handleDetailsClick(transaction.period)}>사용 현황</button>
                                        <button className="business-button" onClick={() => handlPDFdownload(businessdatalist.fnbContractSeq)}>거래서 PDF 다운로드</button>
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div>거래 내역이 없습니다.</div> // 거래 내역이 없을 경우 표시할 메시지
                    )}
                </div>
            )}
        </div>
    );
};

export default FABBusiness;
